import { useAppSelector } from "./hooks";

/**
 * Centralises the role checks that decide who may act on a timesheet.
 *
 * Every role can *see* every status tab (read only); only the roles below may
 * move a timesheet along the DRAFTED -> TO_BE_VERIFIED -> VERIFIED -> APPROVED
 * chain or send it back for changes.
 */
export default function useTimeSheetRoles() {
    const user = useAppSelector((state) => state.user.value);

    const isManagingDirector = user?.roles?.some(
        (role) =>
            role.handle === "MANAGING_DIRECTOR" ||
            role.handle === "HR_ADMINISTRATION_OFFICER",
    );

    const isBDM = user?.roles?.some(
        (role) => role.handle === "BUSINESS_DEVELOPMENT_MANAGER",
    );

    const isDC = user?.roles?.some(
        (role) => role.handle === "DOCUMENT_CONTROLLER",
    );

    const isAdministrator = user?.roles?.some(
        (role) => role.handle === "ADMINISTRATION_OFFICER",
    );

    const isSuperAdmin = user?.is_super_admin;

    const isAdministration =
        isAdministrator || isSuperAdmin || isManagingDirector;

    return {
        isManagingDirector: !!isManagingDirector,
        isBDM: !!isBDM,
        isDC: !!isDC,
        isAdministrator: !!isAdministrator,
        isSuperAdmin: !!isSuperAdmin,
        canEditDraft: !!(isAdministration || isDC),
        canVerify: !!(isAdministration || isBDM),
        canApprove: !!isAdministration,
        canReject: !!(isAdministration || isBDM),
    };
}
